/*
 * @Author: caiqin.xie
 * @since: 2023-06-08 09:47:44
 * @lastTime: 2023-11-10 15:44:36
 * @LastEditors: caiqin.xie
 * @message: 最近的门店
 * @url: www.picoxr.com/cn/shop/nearest-shop
 */
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Pagination from '@/components/Pagination';
import ShopList from "./components/NearestShopList";
import styles from "./index.module.scss";
import { useDevice } from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_LIST, COUNTRY_HREFLANG } from "@/common/const";
import {getUrlData} from "@/common/untils"
import { IShop } from "@/common/types";

const _ = require("lodash");

const NearestShop = (props: any) => {
  const { ctry, words, data } = props.data
  const device = useDevice()
  const [pageNum, setPageNum] = useState<number>(1) // 当前页数
  const [pages, setPages] = useState<number>(data.pages * 1) // 总页数
  const [total, setTotal] = useState<number>(data.total * 1) // 总条数
  const [shopList, setShopList] = useState<IShop[]>(data.records || []) // 门店列表
  const [allShopList, setAllShopList] = useState<IShop[]>(data.records || []) // 所有门店 存储移动端数据

  // 获取门店列表
  function getShopList(pageNum: number) {
    const query = getUrlData()
    request.post(`${DOMAIN_API}/o/official/shop/list`, {
      manageType: '1',
      stationCode: ctry,
      rows: 10,
      page: pageNum,
      ...query
    })
    .then(res => {
      const {total, records, pages} = res.data
      setTotal(total * 1)
      setPages(pages * 1)
      setShopList(records)
      setAllShopList(allShopList => _.uniqBy([...allShopList, ...records], 'id'))
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 分页改变
  const pageChange = (pageNum:number) => {
    setPageNum(pageNum)
    getShopList(pageNum)
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/shop/nearest-shop`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.shop_nearest_list_seo_title}</title>
        <meta name="description" content={words?.shop_nearest_list_seo_description} />
        <meta name="keywords" content={words?.shop_nearest_list_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/shop/nearest-shop`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['shop-wrap']}>
        {/* 内容区 */}
        <div className={styles["shop-content"]}>

          {/* 列表 */}
          <ShopList
            device={device}
            shopList={shopList}
            allShopList={allShopList} />

          {/* 分页 */}
          <Pagination
            words={words}
            device={device}
            pageNum={pageNum}
            pages={pages}
            total={total}
            pageChange={pageChange} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit(query:Record<string,string>) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/shop/list`, {
      manageType: '1',
      ...query,
      rows: 10,
      page: 1
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

NearestShop.getInitialProps = (ctry: string, pathName: string) => {
  const decodedUrl = decodeURIComponent(pathName);
  const query = getUrlData(decodedUrl)
  return getInit({ stationCode:ctry, ...query })
};
export default NearestShop;
